import i18next from 'i18next';

// TODO: localization is not working. need to fix that
export const ErrorMessages = {
  ValueNotFoundInState:
    i18next.t('Value not found in state') || 'Value not found in state',
  DefaulRpcErrorMessage:
    i18next.t('Cannot retrieve value') || 'Cannot retrieve value',
  RequestedAccountNotFound:
    i18next.t('Requested account not found') || 'Requested account not found',
};

export const ErrorMessageByCode = {
  [-32003]: ErrorMessages.ValueNotFoundInState,
};

export const checkIfValueNotFoundInState = (error: string | null): boolean =>
  error === ErrorMessages.ValueNotFoundInState;

export const checkIfRequestedAccountNotFound = (
  error: string | undefined | null
): boolean => error === ErrorMessages.RequestedAccountNotFound;
